import { ApiEvent, OlaggModule, PermissionEnum } from "@olagg/db-types";
import { useEffect, useState } from "react";
import useEvents from "./hooks/useEvents";
import { Table as ChakraTable, Flex, TableContainer, Thead, Tr, Th, Tbody, Td, Button, Image } from "@chakra-ui/react";
import moment from "moment";
import Pagination from "@olagg/ui-kit/Pagination";
import { useNavigate, useSearchParams } from "react-router-dom";
import useRoles from "../../features/Roles/hooks/useRoles";

const Actions = ({ event }: { event: ApiEvent }) => {
    const { missingPermission } = useRoles();
    const { deleteEvent } = useEvents();
    const navigate = useNavigate();
    const viewEvent = (event: ApiEvent) => navigate(`/events/${event.id}/edit`);
    const removeStory = (event: ApiEvent) => {
        if (window.confirm('¿Estás seguro que deseas eliminar este evento?')) {
            deleteEvent(event.id).then(() => {
                console.log("ENTRO ACA")
                window.location.reload();
            }).catch(console.log)
        }
    }

    return (
        <Flex gap='10px'>
            <Button isDisabled={missingPermission(OlaggModule.Event, PermissionEnum.EDIT)} bgColor={'#37A169'} p='0 10px' h='30px' fontSize={'14px'} onClick={() => viewEvent(event)}>
                Ver
            </Button>
            <Button isDisabled={missingPermission(OlaggModule.Event, PermissionEnum.EDIT)} bgColor={'#E53E3E'} p='0 10px' h='30px' fontSize={'14px'} onClick={() => removeStory(event)}>
                Eliminar
            </Button>
        </Flex>
    )
}

const LocalEvents = () => {
    const [events, setEvents] = useState<ApiEvent[]>([]);
    const [count, setCount] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [filter, setFilter] = useState({
        title: searchParams.get('title') || '',
        page: parseInt(searchParams.get('page') || '1'),
        limit: parseInt(searchParams.get('limit') || '10')
    });

    const { getEvents } = useEvents();
    const onFilter = ({
        name,
        value
    }: EventTarget & HTMLInputElement) => {
        const parsedValue = (name === 'page' || name === 'limit') ? parseInt(value) : value;
        
        setFilter({ ...filter, [name]: parsedValue });

        if (value) searchParams.set(name, value);
        else searchParams.delete(name);
        setSearchParams(searchParams);
    }

    const { page, limit, title } = filter

    const fetchEvents = async () => {
        try {
            const response = await getEvents({ 
                limit, 
                page, 
                title 
            });
            setEvents(response.events);
            setCount(response.count);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, [page, limit, title]);

    useEffect(() => {
        const urlPage = searchParams.get('page');
        const urlLimit = searchParams.get('limit');
        const urlTitle = searchParams.get('title');

        if (urlPage || urlLimit || urlTitle) {
            setFilter({
                title: urlTitle || '',
                page: parseInt(urlPage || '1'),
                limit: parseInt(urlLimit || '10')
            });
        }
    }, []);

    return (
        <Flex w={'full'} pb={4} justifyContent='center' flexDirection={'column'}>
            <Flex w='full' justifyContent='center' px={'20px'} pb={'15px'}>
                <TableContainer overflowX={'scroll'} overflowY={'scroll'} w="100%" maxH="60vh">
                    <ChakraTable
                        variant="striped"
                        size="sm"
                        colorScheme="olaggPurple"
                        fontSize="18px"
                        position='relative'
                        whiteSpace={'normal'}
                    >
                        <Thead>
                            <Tr position='sticky' bg='gray.800' top='0' zIndex='100'>
                                <Th py={'20px'} color="white" colSpan={2}>Nombre</Th>
                                <Th py={'20px'} color="white">Estado</Th>
                                <Th py={'20px'} color="white">Creada</Th>
                                <Th py={'20px'} color="white">Última actualización</Th>
                                <Th py={'20px'} color="white">Fecha Inicio</Th>
                                <Th py={'20px'} color="white">Fecha Fin</Th>
                                <Th py={'20px'} color="white">Estado</Th>
                                <Th py={'20px'} color="white">Acciones</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {events?.map((item, index) => (
                                <Tr key={index} color="white">
                                    <Td py={'20px'}><Image src={item?.coverImage?.es} w="40px" h="40px" /></Td>
                                    <Td py={'20px'}>{item?.title?.es}</Td>
                                    <Td py={'20px'}>{item?.status ? 'Activada' : 'Desactivada'}</Td>
                                    <Td py={'20px'}>{item?.createdAt && moment(item?.createdAt).format('DD/MM/YYYY')}</Td>
                                    <Td py={'20px'}>{item?.updatedAt && moment(item?.updatedAt).format('DD/MM/YYYY')}</Td>
                                    <Td py={'20px'}>{item?.startsAt && moment(item?.startsAt).format('DD/MM/YYYY')}</Td>
                                    <Td py={'20px'}>{item?.endsAt && moment(item?.endsAt).format('DD/MM/YYYY')}</Td>
                                    <Td py={'20px'}>{item?.status}</Td>
                                    <Td py={'20px'}>
                                        <Actions event={item} />
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </ChakraTable>
                </TableContainer>
            </Flex>

            <Flex px={'20px'} w='full' justifyContent={'center'}>

                <Pagination
                    params={{ limit, page, count }}
                    onClick={page =>
                        onFilter({
                            name: 'page',
                            value: String(page + 1)
                        } as EventTarget & HTMLInputElement)
                    }
                    onLimitChange={val =>
                        onFilter({
                            name: 'limit',
                            value: val
                        } as EventTarget & HTMLInputElement)
                    }
                    hideLimitInput
                />
            </Flex>
        </Flex>
    )
};

export default LocalEvents;